import styled from "styled-components"

export const DaysOfTheWeekDiv = styled.div`
  display: flex;
  gap: .6rem;
`

export const DayOfTheWeek = styled.div`
  user-select: none;
  cursor: pointer;
  border: 1px solid #919191;
  color: #919191;
  font-weight: 500;
  font-size: .8rem;
  text-align: center;
  border-radius: 50%;
  height: 1.1rem;
  width: 1.1rem;

  &.actived{
    color: #0090D3;
    border-color: #0090D3;
  }
`